module.exports = __webpack_public_path__ + "static/media/HandIconGreen.4d0fa2f9.svg";